import React from "react";
import CheckoutFormSectionDevice from "./CheckoutFormSectionDevice";

const CheckoutFormSection = (props: {
    showPaymentModal: boolean;
    handleClosePaymentModal: () => void;
}) => {
    const { showPaymentModal, handleClosePaymentModal } = props;

    return (
        <CheckoutFormSectionDevice
            showPaymentModal={showPaymentModal}
            handleClosePaymentModal={handleClosePaymentModal}
        />
    );
};

export default CheckoutFormSection;
